import gql from 'graphql-tag';

export const SITEINI_KEY_UPDATE = gql`
  mutation ($id: ID!, $key: String) {
    siteiniDecryptKeyUpdate(id: $id, decrypt_key: $key) {
      id
      decrypt_key {
        status
        key
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/mutations/siteini/updateKey.js